import { handlePaginatedData } from '../services/DataHelperFunctions';
import { EAction } from '../data/Constants';
import AxiosClient from './AxiosClient';
import { handleSuccess, handleError } from './HttpUtil';
import type { Dispatch } from '@reduxjs/toolkit';
import type { ILovRequest, ILovUpdateRequest, ILovDeleteRequest } from '../../types/IApiTypes';

/**
 * API client for list of values (LOV) definitions
 */
export const LovApi = {
  /**
   * Search the paginated list of LOV definitions
   *
   * @param action - Request containing page, limit and an optional search term
   * @param dispatch - Redux dispatch function
   * @returns Paginated LOV data, or an error object on failure
   */
  getLov: (action: ILovRequest, dispatch: Dispatch) => {
    const queryParams = new URLSearchParams({
      Page: String(action.page),
      Limit: String(action.limit),
    });
    if (action.search) queryParams.set('search', action.search);
    return AxiosClient.get(`/lov/v1/read?${queryParams}`)
      .then((response) =>
        handlePaginatedData(response, {
          page: action.page,
          limit: action.limit,
          searchCode: action.search,
        })
      )
      .catch((err) => handleError(dispatch, err, EAction.Read));
  },

  /**
   * Create or update a LOV definition
   *
   * @param action - LOV payload with code, name and optional active flag
   * @param dispatch - Redux dispatch function
   * @returns Success response data, or an error object on failure
   */
  updateLov: (action: ILovUpdateRequest, dispatch: Dispatch) => {
    return AxiosClient.post('/lov/v1/update', action)
      .then((response) => handleSuccess(response))
      .catch((err) => handleError(dispatch, err, EAction.Update));
  },

  /**
   * Delete one or more LOV definitions
   *
   * @param action - Object containing the LOV codes to delete
   * @param dispatch - Redux dispatch function
   * @returns Success response data, or an error object on failure
   */
  deleteLov: (action: ILovDeleteRequest, dispatch: Dispatch) => {
    return AxiosClient.post('/lov/v1/delete', action)
      .then((response) => handleSuccess(response))
      .catch((err) => handleError(dispatch, err));
  },
};
